"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSafeColorCache = clearSafeColorCache;
const color_1 = __importDefault(require("color"));
const log_1 = require("@aurora/shared-utils/log");
const LegacyColorHelper_1 = require("./LegacyColorHelper");
const CssVariableHelper_1 = __importStar(require("./CssVariableHelper"));
const log = (0, log_1.getLog)(module);
const cssVarRegex = new RegExp(/(var\(([\d\s,a-z-]+)\))/g);
let safeColorCache = {};
/**
 * Resolves CSS variables into valid color values. Uses recursion to resolve nested CSS variables.
 * Supports the following formats:
 *
 * --some-var
 * var(--some-var)
 * hsla(var(--lia-bs-gray-900-h), var(--lia-bs-gray-900-s), var(--lia-bs-gray-900-l), 0.2)
 *
 * @param themeToCssVariablesMap a mapping of CSS variables to values
 * @param value the value to resolve
 */
function resolveCssVarFromTheme(themeToCssVariablesMap, value) {
    var _a;
    if (value == null) {
        log.error('No color value specified');
        return null;
    }
    // First check if the value is an unwrapped CSS variable and that it exists in
    // the theme.
    if ((0, CssVariableHelper_1.default)(value)) {
        const resolvedVariable = (_a = themeToCssVariablesMap[value]) !== null && _a !== void 0 ? _a : (0, CssVariableHelper_1.cssVar)(value);
        if (!resolvedVariable) {
            return null;
        }
        return resolveCssVarFromTheme(themeToCssVariablesMap, resolvedVariable);
    }
    else if ((0, LegacyColorHelper_1.isLegacyCustomKey)(value)) {
        // Check if the color value matches one of the legacy color keys. These were only in
        // place for a short while during the development and this should ultimately be removed
        // one all the values are removed from quilts.
        return resolveCssVarFromTheme(themeToCssVariablesMap, (0, LegacyColorHelper_1.getLegacyColor)(value));
    }
    /**
     * Lastly attempt to replace all CSS variables wrapped in a `var()` with values from the theme.
     *
     * LIA-88803 When any of the colors cannot be resolved we track that it was not matched
     * and return null for the method.
     */
    let matched = true;
    const output = value.replaceAll(cssVarRegex, (capture1, capture2, capture3) => {
        const result = resolveCssVarFromTheme(themeToCssVariablesMap, capture3);
        if (!result) {
            matched = false;
            return '';
        }
        return result;
    });
    return matched ? output : null;
}
/**
 * A wrapper around the `color` library that ensures a safe color is created. Supports
 * CSS variables either as the specific color or nested parts of a HSL or RGB color. Resolves
 * CSS variables from the specific theme. CSS variables can either be specific in the format
 * of `--some-var` or `var(--some-var)`. If a color cannot be resolved or an invalid format is used,
 * a default color of `#cccccc` will be returned.
 *
 * @param themeToCssVariablesMap
 * @param color the color
 * @param fallback the fallback color in case the color cannot be processed.
 *
 * @author Adam Ayres
 */
function safeColor(themeToCssVariablesMap, color, fallback = new color_1.default('#cccccc')) {
    if (safeColorCache.hasOwnProperty(color)) {
        return new color_1.default(safeColorCache[color]);
    }
    const updatedColor = resolveCssVarFromTheme(themeToCssVariablesMap, color);
    if (updatedColor) {
        try {
            const colorObject = new color_1.default(updatedColor);
            safeColorCache[color] = updatedColor;
            return colorObject;
        }
        catch (error) {
            log.error('Error creating a safe color for %s: %s', color, error.message);
            return fallback;
        }
    }
    return fallback;
}
function clearSafeColorCache() {
    safeColorCache = {};
}
exports.default = safeColor;
//# sourceMappingURL=SafeColor.js.map